import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { ResourceList } from './ResourceList'

const StudentResource = () => {
	const { user } = useAuth()
	const slug = user?.id

	if (!slug) {
		return (
			<div className="text-center p-5">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		)
	}

	const isStudent = user?.role === 'Student911' || user?.role === 'Student12' || user?.role === 'Student'

	return (
		<StudentTopMenuLayout activeMenu="Resource" pageName="Resource">
			<ResourceList slug={slug} isStudent={isStudent} />
		</StudentTopMenuLayout>
	)
}

export { StudentResource }
